/* global axios */
import ApiClient from './ApiClient';

// O AVISO AO CLIENTE (18/10/2026): a configuração mora no agente do cliente, no Lumos; a fila
// de aprovação aparece no Jurídico (painel e ficha do processo).
class AvisosAoClienteAPI extends ApiClient {
  constructor() {
    super('avisos-ao-cliente', { accountScoped: true });
  }

  ler() {
    return axios.get(this.url);
  }

  // `aviso`: modo, texto, explicador, modelo. `avisarClientes`: o interruptor do agente.
  salvar({ aviso, avisarClientes } = {}) {
    const corpo = {};
    if (aviso) corpo.aviso = aviso;
    if (avisarClientes !== undefined) corpo.avisar_clientes = avisarClientes;
    return axios.patch(this.url, corpo);
  }

  aguardando(legalProcessId = null) {
    return axios.get(`${this.url}/aguardando`, {
      params: legalProcessId ? { legal_process_id: legalProcessId } : {},
    });
  }

  doProcesso(legalProcessId) {
    return axios.get(`${this.url}/processos/${legalProcessId}`);
  }

  // `texto`: o aviso que a equipe editou antes de aprovar (F4.c); sem ele, sai o da leitura.
  aprovar(avisoId, texto = null) {
    return axios.post(
      `${this.url}/avisos/${avisoId}/aprovar`,
      texto ? { texto } : {}
    );
  }

  descartar(avisoId) {
    return axios.post(`${this.url}/avisos/${avisoId}/descartar`);
  }

  ligarClientes() {
    return axios.post(`${this.url}/ligar_clientes`);
  }
}

export default new AvisosAoClienteAPI();
